import Link from 'next/link'
import Avatar from './avatar'
import DateComponent from './date'
import CoverImage from './cover-image'

export default function HeroPost({
    title,
    coverImage,
    date,
    excerpt,
    author,
    slug,
}) {

    return (
        (<section>
            <Link as={`/insights/${slug}`} href="/insights/[slug]">
                <div className={"grid sm:grid-cols-2 sm:gap-0 md:gap-12 lg:grid-cols-2 my-16 insightItem"}>

                    <div data-aos={"zoom-in"} data-aos-delay={500} className={"rounded-lg h-full heroImg"}>
                        <CoverImage title={title} slug={slug} url={coverImage?.url} fullHeight extraClass={"h-full"} />
                    </div>

                    <div className="pt-6 py-12 sm:pt-12 md:col-span-1 lg:col-span-1 sm:p-6 md:p-0 md:py-18 lg:p-6 xl:p-12 sm:gap-6 flex flex-column justify-center" data-aos={"zoom-in"}
                    style={{flexDirection: "column"}}
                    
                    >

                        <div className={"flex flex-row justify-between border-b mb-6 pb-6 text-xl text-gray-500 pt-0 md:pt-0"}>
                            <div className="flex flex-row items-center">
                                <img src={"/images/calendar.svg"} style={{ width: 20, height: 20 }} />
                                <div className={"ml-3"}>
                                    <DateComponent dateString={date} />
                                </div>
                            </div>

                            {/* <div className="flex flex-row items-center">
                                <img src={"/images/clock.svg"} style={{ width: 20, height: 20 }} />
                                <small className={"ml-3 text-sm"}>
                                     {Math.floor(Math.random() * 6) + 1} min Read 
                                </small>
                            </div> */}
                        </div>

                        <h3 className="mb-4 text-3xl lg:text-4xl leading-tight insightTitle">
                            <Link
                                as={`/insights/${slug}`}
                                href="/insights/[slug]"
                                className="hover:underline font-bold">
                                {title}
                            </Link>
                        </h3>

                        <p className="text-lg leading-relaxed mb-6 md:mb-12 text-gray-500 font-normal"> {String(excerpt).substring(0, 100) + "..."}</p>

                        <div data-aos={"fade-up pb-6"}>
                            {author && <Avatar name={author.name} picture={author.picture} title={author.title} />}
                        </div>
                    </div>
                </div>
            </Link>
        </section>)
    );
}